import { Link } from "react-router-dom";
import {
  faArrowRight,
  faBath,
  faBed,
  faLocationDot,
  faRulerCombined,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ListingCard({ property, image }) {
  const isResidential =
    property.PropertyType?.toLowerCase().includes("residential");

  return (
    <Link
      to={`/listing/${property.ListingKey}`}
      className="group block"
    >
      <div className="overflow-hidden bg-white/70 shadow-xl transition-all duration-500">

        {/* Image */}
        <div className="relative h-[250px] overflow-hidden bg-gray-100">
          <img
            // src={image?.MediaURL ?? "/placeholder.jpg"}
            src={image}
            alt={`${property.StreetNumber} ${property.StreetName}`}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
          />

          {/* Price */}
          <div className="absolute left-5 bottom-5">
            <span className="bg-white px-5 py-3 text-lg font-serif text-neutral-800 shadow-sm">
              ${property.ListPrice?.toLocaleString()}
            </span>

          </div>

          {/* Property Type */}
          <div className="absolute right-5 top-5">
            <span className="bg-black/70 px-4 py-2 text-xs uppercase tracking-[0.25em] text-white">
              {property.PropertyType}
            </span>
          </div>
        </div>

        {/* Details */}
        <div className="px-3 py-6">
          <p className="flex items-center text-xs uppercase tracking-[0.25em] text-black/40">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="mr-2"
            />
            {property.CityRegion ?? property.CrossStreet}
          </p>

          <h3 className="mt-4 font-serif text-2xl text-neutral-800">
            {property.StreetNumber} {property.StreetName} {property.StreetSuffix}
          </h3>

          <div className="mt-6 flex items-center justify-between border-t border-black/10 pt-5">
            <div className="flex gap-5 text-sm text-black/50">
              {property.PropertyType !== "Commercial" && (
                <>
                  <span className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faBed} className="text-accent" />
                    {property.BedroomsTotal || property.BedroomsTotalInteger}
                  </span>

                  <span className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faBath} className="text-accent" />
                    {property.BathroomsTotalInteger}
                  </span>
                </>
              )}

              <span className="flex items-center gap-2">
                <FontAwesomeIcon icon={faRulerCombined} className="text-accent" />
                {property.LivingAreaRange ?? "--"} sq.ft.
              </span>
            </div>

            <span className="text-xs uppercase tracking-[0.25em] text-black transition-all duration-300 group-hover:tracking-[0.4em]">
              View
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
